import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Autocomplete, Button, Container, TextField, Typography, useMediaQuery, useTheme } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { Add, Delete, Edit } from "@mui/icons-material";
import { getProductos } from "../../../../api/ApiService";
import { useNavigate } from "react-router-dom";
import { CssTextField } from "../../../../styles/styles";
import { optionsEstadoPromciones } from "../../../../constantes/constantes";



function PromocionesPage() {
    const [loading, setLoading] = useState(false);
    const [dataPromociones, setDataPromociones] = useState([]);
    const [estadoPromociones, setEstadoPromociones] = useState('');
    const [searchName, setSearchName] = useState('');

    const theme = useTheme();
    const mobile = useMediaQuery(theme.breakpoints.down('sm'));

    let history = useNavigate();


    useEffect(() => {
        handleListarProductos();
    }, []);

    const handleListarProductos = () => {

        getProductos(1, 100)
            .then((response) => {
                console.log("response-getProductos", response);
                if (response.body.length > 0) {
                    setDataPromociones(response.body);
                    setLoading(true);
                } else {
                    setDataPromociones([]);
                    setLoading(true);
                }
            })
            .catch((error) => {
                console.log("error-getProductos", error);
                setDataPromociones([]);
                setLoading(true);
            });
    };


    const columns = [
        { field: 'id', headerName: 'ID', width: 90 },
        {
            field: 'nombre',
            headerName: 'Nombre',
            width: 150,
            editable: false,
        },
        {
            field: 'fechaCreacion',
            headerName: 'Vigencia para compra de vales',
            width: 250,
            editable: false,
        },
        {
            field: 'fechaModificacion',
            headerName: 'Vigencia para canje de vales',
            type: 'number',
            width: 110,
            editable: false,
        },
        {
            field: 'descripcion',
            headerName: '¿Mostrar al locatario?',
            // type: 'number',
            width: 110,
            editable: false,
        },
        {
            field: 'status',
            type: '¿Es Prueba?',
            width: 100,
            editable: false,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id }) => {
                return [
                    <GridActionsCellItem
                        icon={<Edit />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<Delete />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];



    //=================================================================================================funcion para editar, obtener el id
    const handleEditClick = (id) => () => {
        console.log('Edit', id);
        // history(`/app/admin/banners-detalle/${id}`, { state: null });
    };

    //=================================================================================================funcion para eliminar, obtener el id
    const handleDeleteClick = (id) => () => {
        console.log('Delete', id);
        setDataPromociones(dataPromociones.filter((row) => row.id !== id));
    }

    //=================================================================================================funcion para ir a la pantalla de agregar
    const handleAddPromocion = () => {
        history('/app/admin/paseo-plus-promociones-agregar', { state: null });
    };


    //=============================================funcion para seleccionar el estado de la promocion
    const handleEstadoSelected = (event) => {
        console.log("event", event);
        setEstadoPromociones(event);
    };


    //=============================================funcion para buscar por nombre
    const handleSearch = (e) => {
        setSearchName(e);
    }

    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>
                {loading ? (
                    <div style={{
                        backgroundColor: PaletaColor.BLANCO,
                        borderRadius: Padding.P1,
                        padding: Padding.P3,
                    }}>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', alignContent: 'center', marginBottom: Padding.P2 }}>
                            <Typography variant={'h5'} style={{}}>
                                Promociones - Paseo Plus
                            </Typography>


                            <div style={{}}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    style={{
                                        backgroundColor: PaletaColor.AZUL_OSCURO,
                                        color: PaletaColor.BLANCO,
                                        fontWeight: 'bold',
                                        // height: 50
                                    }}
                                    startIcon={<Add />}
                                    onClick={handleAddPromocion}
                                >
                                    Crear Promoción
                                </Button>
                            </div>
                        </div>


                        <div style={{ marginTop: Padding.P1 }} >
                            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                <div style={{}}>
                                    <div>
                                        <Typography variant={'subtitle1'} style={{}}>
                                            Buscar
                                        </Typography>
                                    </div>

                                    <CssTextField
                                        value={searchName}
                                        onChange={(e) => handleSearch(e.target.value)}
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        label="Buscar por nombre"
                                        autoCapitalize='none'
                                        autoCorrect={false}
                                        style={{
                                            marginTop: Padding.P1,
                                            width: 500,
                                        }}
                                    />
                                </div>

                                <div style={{ marginLeft: Padding.P4 }}>
                                    <div>
                                        <Typography variant={'subtitle1'} style={{}}>
                                            Estado
                                        </Typography>
                                    </div>

                                    <Autocomplete
                                        disablePortal
                                        options={optionsEstadoPromciones}
                                        sx={{ width: 300 }}
                                        style={{ marginTop: Padding.P1 }}
                                        renderInput={(params) => <TextField {...params} label="Seleccione" />}
                                        onInputChange={(event, newInputValue) => {
                                            handleEstadoSelected(newInputValue);
                                        }}
                                        value={estadoPromociones}
                                    />
                                </div>

                            </div>

                            <div style={{ marginTop: 10, marginBottom: 10 }}>
                                <Typography variant={'subtitle1'} style={{ fontWeight: 'bold' }}>
                                    Obs: Si hay más de una promoción Vigente, el sistema toma la más reciente como válida. Por lo tanto se recomienda tener solo una promoción vigente.
                                </Typography>
                            </div>

                        </div>

                        <DataGrid
                            rows={dataPromociones}
                            columns={columns}
                            rowHeight={100}
                            initialState={{
                                pagination: {
                                    paginationModel: {
                                        pageSize: 5,
                                    },
                                },
                            }}
                            pageSizeOptions={[5]}
                            checkboxSelection
                            disableRowSelectionOnClick
                        />
                    </div>
                ) : (
                    <Container sx={{}} style={{}}>
                        <SkeletonLoading />
                    </Container>
                )}
            </div>
        </HeaderCustom>
    );
}

export default PromocionesPage;